import React, { createContext, useState, useContext, useEffect } from 'react';
import { ApiServices } from '../services/ApiServices';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  // Initialize state from localStorage or default to null/false
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem('user');
    try {
      return storedUser ? JSON.parse(storedUser) : null;
    } catch (e) {
      console.error("Failed to parse user from localStorage", e);
      return null;
    } 
  });
  const [isAuthenticated, setIsAuthenticated] = useState(() => !!localStorage.getItem('authToken')); // Check for a token

  useEffect(() => {
    // Persist user data to localStorage when it changes
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
    } else {
      localStorage.removeItem('user');
    }
  }, [user]);

  useEffect(() => {
    // Update isAuthenticated based on token presence
    setIsAuthenticated(!!localStorage.getItem('authToken'));
  }, []); // Check on initial load

  const login = (userData, token) => {
    localStorage.setItem('authToken', token); // Store the token
    setUser(userData);
    setIsAuthenticated(true);
  };

  const logout = () => {
    if (isAuthenticated) {
      ApiServices.trackAuditEvent('logout', 'auth');
    }
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    setUser(null);
    setIsAuthenticated(false);
    // Optionally redirect to login page here or let ProtectedRoute handle it
  };

  const value = {
    user,
    isAuthenticated,
    login,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
}; 